import { useState } from "react";
import { AiFillStar } from "react-icons/ai";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import { resizeImage } from "../../shared/utils";
import { BsBookmarkHeart, BsBookmarkHeartFill } from "react-icons/bs";

const FilmCardItem = ({ item, genresList }) => {
  const [addedItem, setAddedItem] = useState(false);

  const toggleAddStatus = () => {
    setAddedItem(!addedItem);
  };

  return (
    <div className="shadow-sm bg-dark-darken rounded-md overflow-hidden hover:scale-105 hover:brightness-120 transition duration-300 relative group">
      <Link
        to={
          item.media_type === "movie"
            ? `/movie/${item.id}`
            : item.media_type === "tv"
            ? `/tv/${item.id}`
            : `/`
        }
      >
        <LazyLoadImage
          alt="Poster film"
          src={
            item.media_type === "person"
              ? resizeImage(item.profile_path || "", "w342")
              : resizeImage(item.poster_path, "w342")
          }
          className="object-cover rounded-md !w-[200px] !h-[300px]"
          effect="blur"
        />
      </Link>
      <div className="tw-card-info flex justify-between items-center">
        <div className="flex flex-col justify-center items-start overflow-hidden">
          <span
            className={
              "w-full whitespace-nowrap overflow-hidden text-ellipsis text-base text-gray-300 group-hover:text-white group-hover:font-medium transition duration-300"
            }
          >
            {item.title || item.name}
          </span>
          {item?.genre_ids?.length > 0 && (
            <span
              className={
                "w-full whitespace-nowrap overflow-hidden text-ellipsis text-sm text-gray-400 group-hover:text-gray-200 transition duration-300"
              }
            >
              {genresList[item.genre_ids[0]]}
            </span>
          )}
        </div>
        <div className="p-2 group-hover:text-white group-hover:scale-110">
          {!addedItem ? (
            <BsBookmarkHeart
              size={25}
              className="hover:text-white hover:scale-110 cursor-pointer"
              onClick={toggleAddStatus}
            />
          ) : (
            <BsBookmarkHeartFill
              size={25}
              className="hover:text-white hover:scale-110 cursor-pointer"
              onClick={toggleAddStatus}
            />
          )}
        </div>
      </div>
      <div className="bg-gradient-to-br from-primary to-orange-600 px-2 py-1 rounded-full absolute top-[5%] left-[8%] z-20 flex items-center gap-1 text-white text-xs">
        {item.vote_average?.toFixed(1)}
        <AiFillStar size={15} />
      </div>
    </div>
  );
};

export default FilmCardItem;
